/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index template to autogenerate all the components and extensions
 * Used by "prepareTemplates"
 */

// import all the available components
import Blockquote from './Blockquote'
import Code from './Code'
import Dd from './Dd'
import Div from './Div'
import Dl from './Dl'
import Dt from './Dt'
import H from './H'
import H1 from './H1'
import H2 from './H2'
import H3 from './H3'
import H4 from './H4'
import H5 from './H5'
import H6 from './H6'
import Hr from './Hr'
import Img from './Img'
import Ingress from './Ingress'
import Lead from './Lead'
import Li from './Li'
import Link from './Link'
import Ol from './Ol'
import P from './P'
import Paragraph from './Paragraph'
import Span from './Span'
import Td from './Td'
import Th from './Th'
import Tr from './Tr'
import Ul from './Ul'

// define / export all the available components
export {
  Blockquote,
  Code,
  Dd,
  Div,
  Dl,
  Dt,
  H,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  Hr,
  Img,
  Ingress,
  Lead,
  Li,
  Link,
  Ol,
  P,
  Paragraph,
  Span,
  Td,
  Th,
  Tr,
  Ul,
}

export const getElements = () => {
  return {
    Blockquote,
    Code,
    Dd,
    Div,
    Dl,
    Dt,
    H,
    H1,
    H2,
    H3,
    H4,
    H5,
    H6,
    Hr,
    Img,
    Ingress,
    Lead,
    Li,
    Link,
    Ol,
    P,
    Paragraph,
    Span,
    Td,
    Th,
    Tr,
    Ul,
  }
}
